module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_vizija_mobile-3c89d6b31ecc18ffc959be29f6fc63be.webp";